import Column from '@components/Column';
import styled from '@emotion/styled';
import { ShopInMapRow } from '@models/shop';

import ShopMap from './ShopMap';
import ShopList from '../ShopList';
import useShopsInMap from './hooks/useShopsInMap';

interface Props {
    isOrder?: boolean;
    originalItemId?: string;
    shops?: ShopInMapRow[];
    fetchNext?: ()=> void;
}

function MapAndList({
    isOrder, originalItemId, shops, fetchNext,
}:Props) {
    const { markers } = useShopsInMap({
        originalItemId, isOrder,
    });
    return (
        <Column fullWidth fullHeight>
            <MapContainer>
                <ShopMap markers={markers}
                    shops={shops}
                    isOrder={!!isOrder} />
            </MapContainer>
            <ListContainer>
                <ShopList isOrder={!!isOrder}
                    originalItemId={originalItemId}
                    shops={shops}
                    isBlank={shops?.length === 0}
                    fetchNext={fetchNext}
                    fit />
            </ListContainer>
        </Column>
    );
}

const MapContainer = styled.div`
    width: 100%;
`;

const ListContainer = styled.div`
    margin-top: 24px;
    width: 100%;
`;

export default MapAndList;
